import { Table, Button } from "antd";
import { setOnViewDevice } from "Components/Report/reportSlice";
import { useChartParam, Parameter } from "Components/Report/OnDemand/charts/shared/utils";
import ChartCard from "Components/Report/OnDemand/charts/shared/ChartCard";
import { useAppDispatch, useAppSelector } from "store/hook";
import { cellular_top } from "Utility/Types/report";
import { useReportTop } from "Components/Report/queries";
import type { ColumnsType } from "antd/lib/table";

const UsageTable = ({ param, id = "", isFetching }: { param: Parameter; id?: string; isFetching: boolean }) => {
  const { title } = useChartParam(param, id);
  const { loginCid, stateCid, level } = useAppSelector((status) => status.global);
  const { filterForm } = useAppSelector((status) => status.report);
  const { data: cellularTop } = useReportTop({
    filterForm,
    loginCid,
    stateCid,
    level,
    type: "cellular_top",
  });

  const cellular = cellularTop?.response?.[0]?.cellular_top as cellular_top[];

  const disp = useAppDispatch();

  const columns: ColumnsType<cellular_top> = [
    {
      title: "Location",
      dataIndex: "location",
      ellipsis: true,
      // responsive: ["xxl"],
    },
    {
      title: "Device",
      dataIndex: "deviceID",
      width: 170,
      render: (_: string, record: any) => (
        <Button type="link" onClick={() => disp(setOnViewDevice(record.id))}>
          {record.name !== "" ? record.name : record.id}
        </Button>
      ),
    },
    {
      title: "Model",
      dataIndex: "model",
      ellipsis: true,
      responsive: ["xxl"],
    },

    {
      title: "Tx(MB)",
      dataIndex: "tx",
      ellipsis: true,
      render: (_: any, record: any) => (record.tx / 1024).toFixed(2),
      sorter: (a, b) => a.tx - b.tx,
    },
    {
      title: "Rx(MB)",
      dataIndex: "rx",
      ellipsis: true,
      render: (_: any, record: any) => (record.rx / 1024).toFixed(2),
      sorter: (a, b) => a.rx - b.rx,
    },
    {
      title: "Total(MB)",
      dataIndex: "tx_rx",
      ellipsis: true,
      render: (_: any, record: any) => (record.tx_rx / 1024).toFixed(2),
      sorter: (a, b) => a.tx_rx - b.tx_rx,
      defaultSortOrder: "descend",
    },
  ];

  return (
    <ChartCard title={title} param={param} isFetching={isFetching}>
      {/* <AlarmDetail visible={visible} setVisible={setVisible} /> */}
      <Table
        size="middle"
        columns={columns}
        dataSource={cellular || []}
        pagination={{ pageSize: 5, size: "small", showSizeChanger: false, showQuickJumper: true }}
        rowKey={(record) => record.id}
      />
    </ChartCard>
  );
};

export default UsageTable;
